export default "<ion-button expand=\"block\" color=\"primary\" (click)=\"navigateToLoginPage()\">Avvia</ion-button>";